<template>
  <div class="pb-1">
    <!-- loading -->
    <div v-if="loadpage" class="text-center">
      <b-spinner
        style="width: 5rem; height: 5rem;"
        variant="primary"
        label="Large Spinner"
      />
    </div>

    <div v-if="!loadpage">
      <b-card no-body>
        <b-card-header class="d-flex justify-content-between align-items-center flex-wrap">
          <h4 class="mb-0">ตรวจสอบแจ้งชำระเงิน</h4>
          <b-button
            variant="success"
            size="sm"
            :disabled="selectedIds.length === 0 || loadButton === false"
            @click="approveSelected()"
          >
            <b-spinner v-if="loadButton === false" small />
            <feather-icon v-else icon="CheckCircleIcon" size="16" class="mr-25" />
            อนุมัติที่เลือก ({{ selectedIds.length }})
          </b-button>
        </b-card-header>
        <hr class="my-0 mx-2">

        <b-card-body>
          <!-- filter -->
          <div class="d-md-flex align-items-center mb-1 pl-md-0 col-md-9 px-0">
            <span class="px-0 col-md-1"> วันที่: </span>
            <flat-pickr v-model="dateFrom" class="form-control" :config="datePickerConfig"/>
            <span class="px-1"> - </span>
            <span class="px-0 col-md-1"> ถึงวันที่: </span>
            <flat-pickr v-model="dateTo" class="form-control mr-1" :config="datePickerConfig"/>
            <b-button variant="primary" @click="getList()">ค้นหา</b-button>
          </div>

          <b-table
            responsive
            :items="items"
            :fields="fields"
            bordered
            show-empty
            empty-text="ไม่มีรายการที่รอตรวจสอบ"
            table-class="table-md-responsive text-nowrap"
          >
            <!-- select all header -->
            <template #head(select)>
              <b-form-checkbox
                :checked="allSelected"
                :indeterminate="someSelected"
                @change="toggleSelectAll"
              />
            </template>
            <!-- row checkbox -->
            <template #cell(select)="data">
              <b-form-checkbox
                :checked="selectedIds.includes(data.item.paymentID)"
                @change="toggleSelect(data.item.paymentID)"
              />
            </template>

            <template #cell(informDate)="data">
              {{ formatDatetime(data.value) }}
            </template>

            <template #cell(firstName)="data">
              <div>{{ data.value }}</div>
              <small class="text-muted" v-if="data.item.taobaoReceiveName">{{ data.item.taobaoReceiveName }}</small>
            </template>

            <template #cell(amountPaid)="data">
              <div class="text-right">{{ format_price(data.value) }}</div>
            </template>

            <template #cell(photoLink)="data">
              <b-img
                v-if="data.value"
                :src="data.value"
                class="cursor-pointer"
                width="45px"
                @click="showImg(data.value)"
              />
              <span v-else class="text-muted">-</span>
            </template>

            <template #cell(statusID)="data">
              <b-badge :variant="statusVariant(data.value)">{{ statusText(data.value) }}</b-badge>
            </template>

            <!-- actions -->
            <template #cell(actions)="data">
              <b-button
                variant="outline-success"
                size="sm"
                class="btn-icon mr-50"
                :id="`approve-${data.item.paymentID}`"
                :disabled="loadButton === false"
                @click="approveOne(data.item.paymentID)"
              >
                <feather-icon icon="CheckIcon" size="16" />
              </b-button>
              <b-tooltip title="อนุมัติ" :target="`approve-${data.item.paymentID}`" :delay="{show: '800'}"/>

              <b-button
                variant="outline-danger"
                size="sm"
                class="btn-icon"
                :id="`reject-${data.item.paymentID}`"
                :disabled="loadButton === false"
                @click="rejectOne(data.item)"
              >
                <feather-icon icon="XIcon" size="16" />
              </b-button>
              <b-tooltip title="ปฏิเสธ" :target="`reject-${data.item.paymentID}`" :delay="{show: '800'}"/>
            </template>
          </b-table>
        </b-card-body>
      </b-card>
    </div>

    <!-- slip image modal -->
    <b-modal ref="show-img" hide-footer centered title="สลิปการชำระเงิน">
      <div class="text-center">
        <b-img class="px-0" :src="imgLink" fluid />
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BTable, BButton, BSpinner, BImg,
  BFormCheckbox, BBadge, BTooltip, BModal,
} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import { format_price, formatDatetime } from '@/views/global_function.js'
import { header_token } from '@/views/token.js'
import { taobaoService_dotnet } from '@/views/global.js'
import axios from 'axios'

export default {
  name: 'AdminBranchCheckPayment',

  components: {
    BCard, BCardHeader, BCardBody, BTable, BButton, BSpinner, BImg,
    BFormCheckbox, BBadge, BTooltip, BModal,
    flatPickr,
  },

  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),

      loadpage: true,
      loadButton: true,

      dateFrom: null,
      dateTo: null,
      datePickerConfig: {
        altInput: true,
        altFormat: 'd-m-Y',
      },

      items: [],
      selectedIds: [],

      fields: [
        { key: 'select', label: '', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'informDate', label: 'แจ้งเมื่อ', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'firstName', label: 'ลูกค้า' },
        { key: 'bankName', label: 'ช่องทาง' },
        { key: 'description', label: 'เพื่อชำระ' },
        { key: 'amountPaid', label: 'ยอด', thClass: 'text-right', tdClass: 'text-right' },
        { key: 'photoLink', label: 'สลิป', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'remark', label: 'หมายเหตุ' },
        { key: 'statusID', label: 'สถานะ', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'actions', label: 'จัดการ', thClass: 'text-center', tdClass: 'text-center' },
      ],

      imgLink: '',
    }
  },

  computed: {
    staffBranchID() {
      return this.userData && this.userData.data ? this.userData.data.customerID : null
    },
    branchID() {
      return this.userData && this.userData.data ? this.userData.data.branchID : null
    },
    allSelected() {
      return this.items.length > 0 && this.selectedIds.length === this.items.length
    },
    someSelected() {
      return this.selectedIds.length > 0 && this.selectedIds.length < this.items.length
    },
  },

  async created() {
    await this.getList()
    this.loadpage = false
  },

  methods: {
    format_price, formatDatetime,

    async getList() {
      try {
        let response = await axios.post(
          taobaoService_dotnet + 'app/AdminBranch/check-payment-list',
          {
            customerID: null,
            branchID: this.branchID,
            dateFrom: this.dateFrom,
            dateTo: this.dateTo,
          },
          { headers: header_token }
        )
        this.items = response.data.items || []
        // keep only still-visible selections
        const visibleIds = this.items.map(i => i.paymentID)
        this.selectedIds = this.selectedIds.filter(id => visibleIds.includes(id))
      } catch (e) {
        console.error(e)
        this.$bvToast.toast('โหลดข้อมูลไม่สำเร็จ', {
          title: 'ผิดพลาด', variant: 'danger', solid: true, toaster: 'b-toaster-top-right'
        })
      }
    },

    toggleSelect(id) {
      const idx = this.selectedIds.indexOf(id)
      if (idx === -1) this.selectedIds.push(id)
      else this.selectedIds.splice(idx, 1)
    },

    toggleSelectAll(checked) {
      this.selectedIds = checked ? this.items.map(i => i.paymentID) : []
    },

    statusText(statusID) {
      if (statusID === 5 || statusID === 6) return 'รอตรวจ (หักหยวน)'
      return 'รอตรวจสอบ'
    },
    statusVariant() {
      return 'light-warning'
    },

    async showImg(img) {
      this.imgLink = img
      this.$refs['show-img'].show()
    },

    async approveOne(paymentID) {
      await this.doApprove([paymentID], 'อนุมัติรายการเรียบร้อย')
    },

    async approveSelected() {
      if (this.selectedIds.length === 0) return
      this.$swal({
        title: 'ยืนยันการอนุมัติ',
        text: `ต้องการอนุมัติ ${this.selectedIds.length} รายการที่เลือกใช่หรือไม่?`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'อนุมัติ',
        cancelButtonText: 'ยกเลิก',
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-outline-secondary ml-1',
        },
        buttonsStyling: false,
      }).then(async (result) => {
        if (result.value) {
          await this.doApprove([...this.selectedIds], null)
        }
      })
    },

    async doApprove(paymentIDs, successMsg) {
      this.loadButton = false
      try {
        let response = await axios.post(
          taobaoService_dotnet + 'app/AdminBranch/approve-payment',
          {
            paymentIDs,
            staffBranchID: this.staffBranchID,
          },
          { headers: header_token }
        )
        const data = response.data
        if (data.status === 'success') {
          this.$bvToast.toast(successMsg || data.message, {
            title: 'สำเร็จ', variant: 'success', solid: true, toaster: 'b-toaster-top-right'
          })
          if (data.failCount > 0) {
            this.$bvToast.toast(data.message, {
              title: 'บางรายการไม่สำเร็จ', variant: 'warning', solid: true, toaster: 'b-toaster-top-right'
            })
          }
        } else {
          this.$bvToast.toast(data.message || 'อนุมัติไม่สำเร็จ', {
            title: 'ผิดพลาด', variant: 'danger', solid: true, toaster: 'b-toaster-top-right'
          })
        }
        await this.getList()
      } catch (e) {
        console.error(e)
        this.$bvToast.toast('เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง', {
          title: 'ผิดพลาด', variant: 'danger', solid: true, toaster: 'b-toaster-top-right'
        })
      } finally {
        this.loadButton = true
      }
    },

    async rejectOne(item) {
      this.$swal({
        title: 'ปฏิเสธการแจ้งชำระเงิน?',
        text: `ต้องการลบรายการของ "${item.firstName}" ยอด ${this.format_price(item.amountPaid)} ใช่หรือไม่?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'ปฏิเสธ',
        cancelButtonText: 'ยกเลิก',
        customClass: {
          confirmButton: 'btn btn-danger',
          cancelButton: 'btn btn-outline-secondary ml-1',
        },
        buttonsStyling: false,
      }).then(async (result) => {
        if (result.value) {
          this.loadButton = false
          try {
            let response = await axios.post(
              taobaoService_dotnet + 'app/AdminBranch/reject-payment',
              {
                paymentID: item.paymentID,
                staffBranchID: this.staffBranchID,
              },
              { headers: header_token }
            )
            if (response.data.status === 'success') {
              this.$bvToast.toast('ปฏิเสธรายการเรียบร้อย', {
                title: 'สำเร็จ', variant: 'success', solid: true, toaster: 'b-toaster-top-right'
              })
            } else {
              this.$bvToast.toast(response.data.message || 'ปฏิเสธไม่สำเร็จ', {
                title: 'ผิดพลาด', variant: 'danger', solid: true, toaster: 'b-toaster-top-right'
              })
            }
            await this.getList()
          } catch (e) {
            console.error(e)
            this.$bvToast.toast('เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง', {
              title: 'ผิดพลาด', variant: 'danger', solid: true, toaster: 'b-toaster-top-right'
            })
          } finally {
            this.loadButton = true
          }
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
